export const isSandbox = PHASE === 'sandbox';
export const isCBT = PHASE === 'cbt';
export const isDev = isSandbox || isCBT;
